const MENU_TYPES = {
    DETAIL: "detail",
    EXPLORER: "explorer",
    VISIBILITY: "visibility",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("googleDrive.channelSettings") || "Channel Settings",
        icon: {
            type: "material-icons",
            name: "settings",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.EXPLORER,
        label: that?.$t("googleDrive.driveExplorer") || "Drive Explorer",
        icon: {
            type: "material-icons",
            name: "folder",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("multi_whatsapp_api.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
